export class MalformedSmartlingResponseError extends Error {
  readonly name: string = 'MalformedSmartlingResponseError';
  constructor(reason: string) {
    super(
      `This should not happen, this is a malformed response object from Smartling, because: ${reason}. Please check if it is a Smartling API issue or a configuration issue.`,
    );
  }
}
